import { useQuery } from "@apollo/client"
import { useMemo } from "react"
import { BITKUB_ORDER_HISTORY } from "src/graphql/queries/bitkubExecution"
import { bitkubOrderHistoryQuery, bitkubOrdersHistoryInputType } from "src/types/bitkub-execution-types"

interface hookProps {
  executionID?:string
  start?:string
  end?:string
}

const useBitkubExecutionOrderHistoryQuery = (props:hookProps) => {
  const { data:Data,...query } = useQuery<bitkubOrderHistoryQuery>(BITKUB_ORDER_HISTORY,{
    variables:{
      executionID:props.executionID,
      start: props.start ? (new Date(props.start)).toLocaleDateString('fr-ca') : undefined,
      end:props.end ? (new Date(props.end)).toLocaleDateString('fr-ca') : undefined,

    } as bitkubOrdersHistoryInputType,
    skip: props.executionID === ""
  })

  const data = useMemo(()=>{
    if (Data?.bitkubOrdersHistory?.__typename === "BitkubOrdersHistory") {
      return Data.bitkubOrdersHistory
    }
  },[Data])

  const error = useMemo(()=>{
    if (Data?.bitkubOrdersHistory?.__typename === "Error") {
      return Data.bitkubOrdersHistory
    }
  },[Data])

  return {
    data,
    error,
    query
  }

}

export default useBitkubExecutionOrderHistoryQuery